import React from "react";
import {
  ListItemAvatar,
  Box,
  styled,
  Avatar,
  AvatarProps,
} from "@material-ui/core";
import { styledListIcon } from "./styledListIcon";

const StyledListItemAvatar = styledListIcon(ListItemAvatar);

export const ActivityAvatar = styled(({ isPending, ...other }) => (
  <Avatar {...other} />
))(({ isPending, theme }) => ({
  color: theme.palette.secondary.contrastText,
  backgroundColor: isPending
    ? theme.palette.text.disabled
    : theme.palette.secondary.main,
  width: 24,
  height: 24,
  "& svg": {
    fill: "currentColor",
  },
})) as React.FC<AvatarProps & { isPending?: boolean }>;

export const ActivityListItemAvatar: React.FC<{ isPending: boolean }> = ({
  children,
  isPending,
}) =>
  isPending ? (
    <StyledListItemAvatar data-testid="ActivityPanel__ListItemAvatar">
      <ActivityAvatar isPending={isPending}>{children}</ActivityAvatar>
    </StyledListItemAvatar>
  ) : (
    <Box alignSelf="flex-start" marginTop={1} clone>
      <StyledListItemAvatar data-testid="ActivityPanel__ListItemAvatar">
        <ActivityAvatar isPending={isPending}>{children}</ActivityAvatar>
      </StyledListItemAvatar>
    </Box>
  );
